<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content class="tw-flex tw-justify-between tw-items-center">
        <h1 class="tw-text-xl sm:tw-text-2xl tw-leading-tight tw-text-gray-900 tw-mb-0 tw-font-thin">Subscription Reconciliation</h1>
        <div class="tw-flex tw-gap-3">
          <base-select label="Business" placeholder="Choose a business" v-model="selectedBusinessId" :options="businesses" labelKey="name" valueKey="id" />
        </div>
      </base-content>
    </div>
    <base-content>
      <base-table :loading="isLoading" :fields="fields" :items="items" class="tw-mt-2">
        <template #user="{item: plan}">
          <div class="tw-whitespace-nowrap">{{ plan.userName }}</div>
          <div class="tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">{{ plan.userId }}</div>
        </template>
        <template #plan="{item: plan}">
          <div class="tw-whitespace-nowrap">{{ plan.userBusinessPlanName }}</div>
          <div class="tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">{{ plan.userBusinessPlanId }}</div>
        </template>
        <template #subscription="{item: plan}">
          <div class="tw-whitespace-nowrap">{{ plan.subscriptionPlanName }}</div>
          <div class="tw-text-xs tw-text-gray-500 tw-whitespace-nowrap">{{ plan.subscriptionId }}</div>
        </template>
        <template #empty-state>
          <div class="tw-flex tw-justify-center tw-py-5">
            No Results
          </div>
        </template>
        <template #loading-row>
          <td class="tw-py-3 tw-px-4">
            <base-skeleton-loader class="tw-h-4 tw-w-24" />
            <base-skeleton-loader class="tw-h-3 tw-w-56 tw-mt-2" />
          </td>
          <td class="tw-py-3 tw-px-4">
            <base-skeleton-loader class="tw-h-4 tw-w-24" />
            <base-skeleton-loader class="tw-h-3 tw-w-56 tw-mt-2" />
          </td>
          <td class="tw-py-3 tw-px-4">
            <base-skeleton-loader class="tw-h-4 tw-w-24" />
            <base-skeleton-loader class="tw-h-3 tw-w-56 tw-mt-2" />
          </td>
        </template>
      </base-table>
    </base-content>
  </div>
</template>

<script>
export default {
  name: "SubscriptionReconcileView",
  components: {},
  data() {
    return {
      fields: [
        { title: "Predictile User", key: "user", thClass: "tw-w-0 tw-text-left" },
        { title: "Predictile Plan", key: "plan", thClass: "tw-w-0 tw-text-left" },
        { title: "Stripe Subscription", key: "subscription" },
      ],
      items: [],
      businesses: [],
      selectedBusinessId: null,
      isLoading: false,
    };
  },
  created() {
    this.loadBusinesses();
  },
  watch: {
    selectedBusinessId() {
      this.loadPage();
    },
  },
  methods: {
    loadBusinesses() {
      let url = `/businesses/list`;

      this.$axios
        .get(url)
        .then((res) => {
          this.businesses = res.data;
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Unable to load businesses",
            message: "We were not able to retrieve the list of businesses. Please reload the page to try again.",
            err,
          });
        });
    },
    loadPage() {
      this.isLoading = true;

      let url = `/admin/subscription-reconcile`;

      this.$axios
        .get(url)
        .then((res) => {
          this.items = res.data.filter((x) => x.businessId === this.selectedBusinessId);
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: "Unable to load subscriptions",
            message: "We were not able to retrieve the list. Please reload the page to try again.",
            err,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
